import documentsService from '../../solicitation/documents.service';
import requestServicesService from '../../solicitation/request.services.service';

const find = async (requestId) =>
    documentsService
        .findServiceDocuments(requestId)
        .then(res => res.data || {});

const getRequestServices = (requestId) =>
    requestServicesService
        .findProductionServices(requestId)
        .then((res) => mapServices(res.data))
        .catch(() => []);

const mapServices = (services = []) => {

    const mappedServices = services.map(item => ({
        ...item,
        value: item.serviceId,
        name: item.serviceName || item.name,
    }));

    const emptyAnswer = { value: 0, name: 'Nenhum (não recomendado)' };

    return [emptyAnswer, ...mappedServices];
};

const requestServiceDocumentService = {
    find,
    getRequestServices,
};

export default requestServiceDocumentService;
